import Prices from '../components/pages/Prices';

export default Prices;
